"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'yesno',
  label: 'Yes/No',
  applyToTypes: ['boolean'],
  initialSettings: {
    ifTrue: 'Yes',
    ifFalse: 'No'
  },
  SettingsComponent: function SettingsComponent() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "ifTrue",
      component: _cccisdFormik.CccisdInput,
      label: "if True"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "ifFalse",
      component: _cccisdFormik.CccisdInput,
      label: "if False"
    })));
  },
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row;
        var ifTrue = settings.ifTrue,
          ifFalse = settings.ifFalse;
        return value ? ifTrue : ifFalse;
      }
    };
  }
};